import { render, staticRenderFns } from "./ResourceQuene.vue?vue&type=template&id=2a87cd71"
import script from "./ResourceQuene.vue?vue&type=script&lang=js"
export * from "./ResourceQuene.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports